
<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pa-3">
        <ValidationObserver ref="clarification">
          <validatable-textarea
              v-model="clarification.question"
              :rules="{ required: true,
                        max: 4000 }"
              :label="$t('Текст запроса')" />
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="saveBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="save">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextarea from '@/components/reused/ui/ValidatableTextarea.vue'
  import { mapActions } from 'vuex'
  import { LOT_CLARIFICATIONS_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableTextarea
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false,
            lot: null,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        clarification: {
          question: null
        }
      }
    },
    computed: {
      title () {
        return this.$t('Запрос на разъяснение по документам')
      }
    },
    methods: {
      ...mapActions(LOT_CLARIFICATIONS_MANAGEMENT.NAMESPACE, {
        createClarificationAction: LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.CREATE_CLARIFICATION
      }),
      save: async function () {
        try {
          const result = await this.$refs.clarification.validate()
          if (!result) {
            return
          }

          this.isLoading = true
          await this.createClarificationAction({
            lotId: this.dialogProp.lot.lotId,
            lotType: this.dialogProp.lot.lotType,
            clarification: this.clarification
          })
          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
